import {createStore} from '@stripe-internal/state-manager';

import type {RetrieveReturnDetailsCollectionSessionQueryData} from 'src/return/api/useRetrieveReturnDetailsCollectionSessionQuery';
import {MERCHANT_BRANDING_DEFAULTS} from 'src/v2/util/merchantBrandingDefaults';
import type {GraphQlField} from '@sail/data';

type RetrieveReturnDetailsCollectionSessionResponse = GraphQlField<
  RetrieveReturnDetailsCollectionSessionQueryData,
  'v1CryptoInternalReturnDetailsCollectionSessionReturnDetailsCollectionSession'
>;

export type ReturnDetailsCollectionState = {
  cryptocurrency:
    | RetrieveReturnDetailsCollectionSessionResponse['cryptocurrency']
    | null;
  id: RetrieveReturnDetailsCollectionSessionResponse['id'];
  merchantBranding: {
    buttonColor: RetrieveReturnDetailsCollectionSessionResponse['buttonColor'];
    logo: RetrieveReturnDetailsCollectionSessionResponse['logo'];
    merchantName: RetrieveReturnDetailsCollectionSessionResponse['merchantName'];
  };
  network: RetrieveReturnDetailsCollectionSessionResponse['network'] | null;
  state: RetrieveReturnDetailsCollectionSessionResponse['state'];
  submittedWalletAddress: string | null;
};

const initialValues: ReturnDetailsCollectionState = {
  cryptocurrency: null,
  id: '',
  merchantBranding: {
    buttonColor: MERCHANT_BRANDING_DEFAULTS.buttonColor,
    logo: null,
    merchantName: '',
  },
  network: null,
  state: 'created',
  submittedWalletAddress: null,
};

const store = createStore(initialValues);

export const getStore = () => store;

export const {setValue, useSelector} = getStore();
